<!-- 菜单  -->
<template>
  <el-menu
    :default-active="$route.path"
    class="el-menu-vertical-demo"
    :collapse="menuCollapse"
    active-text-color="white"
    style="border: none"
    :collapse-transition="false"
    @select="handleSelect"
    :class="{'mobile-menu': !isPC}"
  >
    <template v-for="(item, index) in menuList">
      <!-- 有子菜单 -->
      <el-submenu v-if="item.children" :index="item.path || String(index)" :key="item.name">
        <template slot="title">
          <i class="iconfont mr5" :class="[item.icon]"></i>
          <span slot="title" class="ellipsis" :title="$t(item.name)">{{$t(item.name)}}</span>
        </template>
        <template v-for="child in item.children">
          <el-menu-item v-if="child.name!=='API' || (child.name==='API' && authorities)" :key="child.name" :index="child.path" class=" ellipsis" :title="$t(child.name)">{{$t(child.name)}}</el-menu-item>
        </template>
      </el-submenu>
      <!-- 没有子菜单 -->
      <el-menu-item v-else :key="item.name" :index="item.path || index">
        <i class="iconfont mr5" :class="[item.icon]"></i>
        <span slot="title" class="ellipsis" :title="$t(item.name)">{{$t(item.name)}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import { pcMenuList, mobileMenuList } from '@/config/menuList.js'
export default {
  computed: {
    menuList() {
      return this.isPC ? pcMenuList : mobileMenuList
    },
    menuCollapse() {
      return this.isPC && this.$store.state.menuCollapse
    },
    authorities() {
      return (this.$store.state.common.authorities && this.$store.state.common.authorities.includes('2')) || false
    }
  },
  methods: {
    handleSelect(path) {
      this.$router.push(path)
      this.$emit('select', path)
    }
  }
}
</script>

<style lang="scss" scoped>
/* el-menu样式修改 */
/deep/.el-menu-item.is-active {
  background: #2e485b!important;
  color: white!important;
}

/deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 208px;
  height: 100%;
}
/* 一级/二级菜单hover */
/deep/.el-menu .el-submenu__title:hover, /deep/.el-menu .el-menu-item:hover {
    background-color: #2e485b10;
}
.mobile-menu /deep/ .el-submenu__title{
  font-size: .28rem;
  height: 1rem!important;
  line-height: 1rem!important;
}
.mobile-menu  /deep/ .el-menu-item{
  font-size: .28rem;
  height: 1rem!important;
  line-height: 1rem!important;
}
.mobile-menu /deep/ .el-submenu .el-menu-item{
  font-size: .24rem;
}
.mr5{
  margin-right: 5px;
  color: #000;
}
</style>
<style>
.el-menu--vertical .el-menu-item.is-active {
  color: black!important;
}
</style>
